

import { globalRegex } from '@Src/utils/regex/regex.constant';
import { ValidFields } from '@Src/utils/messages/validFields.constant';
import * as Yup from 'yup';

export const UpdatePasswordSchema = Yup.object({
    oldPassword: Yup.string().min(ValidFields.PASSWORD.MIN, ValidFields.PASSWORD.SHORT_MESSAGE).required(ValidFields.PASSWORD.REQUIRED).matches(globalRegex.PASSWORD.REGEX, globalRegex.PASSWORD.MESSAGE),
    newPassword: Yup.string().min(ValidFields.PASSWORD.MIN, ValidFields.PASSWORD.SHORT_MESSAGE).required(ValidFields.NEW_PASSWORD.REQUIRED).matches(globalRegex.PASSWORD.REGEX, globalRegex.PASSWORD.MESSAGE),
    re_newPassword: Yup.string().oneOf([Yup.ref('newPassword')], "Password Doesn't match ").min(ValidFields.PASSWORD.MIN, ValidFields.PASSWORD.SHORT_MESSAGE).required(ValidFields.ConForm_PASSWORD.REQUIRED).matches(globalRegex.PASSWORD.REGEX, globalRegex.PASSWORD.MESSAGE),
})

export const perosnalProfileSchema = Yup.object({
    FirstName: Yup.string().min(ValidFields.FIRST_NAME.MIN, ValidFields.FIRST_NAME.SHORT_MESSAGE).max(ValidFields.FIRST_NAME.MAX, ValidFields.FIRST_NAME.LONG_MESSAGE).required(ValidFields.FIRST_NAME.REQUIRED).matches(globalRegex.ONLY_ALBHABET.REGEX, globalRegex.ONLY_ALBHABET.MESSAGE),
    LastName:Yup.string().min(ValidFields.LAST_NAME.MIN, ValidFields.LAST_NAME.SHORT_MESSAGE).max(ValidFields.LAST_NAME.MAX, ValidFields.LAST_NAME.LONG_MESSAGE).required(ValidFields.LAST_NAME.REQUIRED).matches(globalRegex.ONLY_ALBHABET.REGEX, globalRegex.ONLY_ALBHABET.MESSAGE),
    PhoneNo: Yup.string().min(ValidFields.MOBILE.MIN, ValidFields.MOBILE.SHORT_MESSAGE).max(ValidFields.MOBILE.MAX, ValidFields.MOBILE.LONG_MESSAGE).required(ValidFields.MOBILE.REQUIRED).matches(globalRegex.MOBILE_NUMBER.REGEX, globalRegex.MOBILE_NUMBER.MESSAGE),
    DOB: Yup.date().nullable().required(ValidFields.DATE_OF_BIRTH.REQUIRED),
    Gender: Yup.string().required(ValidFields.GENDER.REQUIRED),
    CityId: Yup.number().required(ValidFields.CITY.REQUIRED),
    stateId: Yup.string().required(ValidFields.STATE.REQUIRED),
    school: Yup.string().required(ValidFields.SCHOOL.REQUIRED).max(100,"School name must be within 100 characters"),
    countryCode: Yup.string(),
    Nickname: Yup.string().max(250,"Nickname must e within 250 characters").matches(globalRegex.ONLY_ALBHABET.REGEX, globalRegex.ONLY_ALBHABET.MESSAGE),
    Address: Yup.string(),
    ParentEmailId: Yup.string().email('Invalid email format').max(100, "Parent email must be within 100 characters"),
    ParentPhone: Yup.string().matches(globalRegex.MOBILE_NUMBER.REGEX, globalRegex.MOBILE_NUMBER.MESSAGE),
    ParentCountryCode: Yup.string(),
})

export const EditProfileInitialValue = {
    FirstName:'',
    LastName:'',
    PhoneNo: '',
    DOB: null,
    Gender: '',
    CityId: null as any,
    stateId: '',
    school: '',
    countryCode: '',
    Nickname: '',
    Address: '',
    ParentEmailId: '',
    ParentPhone: '',
    ParentCountryCode: ''
}

export const UpdatePasswordInitialvalue = {
    oldPassword: '',
    newPassword: '',
    re_newPassword: ''
}

export const EditCoursePrefernces = {
    languageListId: '',
    classlistId: null,
    boardListId: '',
    subjectListId: [] as any[],
    educationInterestListId: ''
}
